import React, { useEffect, useState, useContext } from 'react';
import { Header, Icon, Container, Card, Button, Message } from 'semantic-ui-react'
import { SiCoffeescript } from 'react-icons/si';
import { MdDoNotDisturbOff } from 'react-icons/md';
import { BiCoffeeTogo } from 'react-icons/bi';
import { SiBuymeacoffee } from 'react-icons/si';
import { ConnectWS } from '../../../../ConnectWS';
import AuthContext from '../../../../context/authContext';

function BuyCoffe() {
  const [form, setForm] = useState(null);
  const [message, setMessage] = useState(null);
  const authContext = useContext(AuthContext);


  function generateHotPayData(amount) {
    ConnectWS("/payment/generateHotPayDataDonate", null, { amount: amount }, function (response, logout) {
 
      if (logout === 1) {
        setMessage(response.data)
        setForm(null)
      } else if (response && response.status && Number(response.status) === 200) {
        //setRowDataTournament(response.data)
        setForm(response.data)
        document.getElementById("orderHP").submit();
        setMessage(null)
      } else {

        console.log(response);
        setForm(null)
        setMessage(response)
      }

    });
  }

  function sendLogCoffeClick() {
    
    ConnectWS("/payment/clickDonate", authContext.token, {source_widget:document.title}, function (response, logout) {

      if (logout === 1) {

      } else if (response && response.status && Number(response.status) === 200) {

      } else {

        console.log(response);

      }

    });
  }

  useEffect(() => {
    sendLogCoffeClick()
    return () => { }; // use effect cleanup to set flag false, if unmounted
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container textAlign='center'>
      <Header as='h3' icon>

        <span style={{ fontSize: 50, color: "#c33c3c", margin: 0, padding: 0, }} ><SiCoffeescript />
        </span>
        <br />
        Podaruj nam filiżankę kawy
        <Header.Subheader>
        a wspomożesz naszą pasję i twórczość.
        </Header.Subheader>
      </Header>
      <br />
      <p>
        <i> Niby mały gest, a jednak tak bardzo motywuje do dalszego działania.</i>
      </p>
      {message ? <Message negative>
        <Message.Header>ERROR</Message.Header>
        <p>{message}</p>
      </Message> : ""}
      <Card.Group centered>

        <Card link color='teal' onClick={() => generateHotPayData(10)} className={"cardpay"}>
          <Card.Content className='ContentCenter'>
            <span style={{ fontSize: 35, margin: 0, padding: 0, }} className='ContentCenterIcon1'><SiCoffeescript />
            </span>
            <Card.Header>MAŁA KAWA</Card.Header>
            <Card.Meta style={{ fontSize: 12, lineHeight: 1.1,color:"#4B4B4B" }}><Icon name="credit card" /> PŁATNOŚĆ BLIK LUB ONLINE</Card.Meta>
            <Card.Meta style={{ fontSize: 12, lineHeight: 1.1,color:"#4B4B4B" }}><MdDoNotDisturbOff /> BEZ REJESTRACJI</Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <Button basic color='teal' id="buycoffe5click">
              <b>WSPIERAM ZA 10 PLN</b>
            </Button>
            <br/><div style={{fontSize:12,marginTop:5}}>
            Płatność jednorazowa
            </div>
          </Card.Content>
        </Card>

        <Card link color='green' onClick={() => generateHotPayData(15)} className={"cardpay"}>
          <Card.Content className='ContentCenter' >
            <span style={{ fontSize: 50, margin: 0, padding: 0 }} className='ContentCenterIcon2'><SiCoffeescript />
            </span>
            <Card.Header>ŚREDNIA KAWA</Card.Header>
            <Card.Meta style={{ fontSize: 12, lineHeight: 1.1,color:"#4B4B4B" }}><Icon name="credit card" /> PŁATNOŚĆ BLIK LUB ONLINE</Card.Meta>
            <Card.Meta style={{ fontSize: 12, lineHeight: 1.1,color:"#4B4B4B" }}><MdDoNotDisturbOff /> BEZ REJESTRACJI</Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <Button basic color='green' id="buycoffe10click">
              <b>WSPIERAM ZA 15 PLN</b>
            </Button>
            <br/><div style={{fontSize:12,marginTop:5}}>
            Płatność jednorazowa
            </div>
          </Card.Content>
        </Card>

        <Card link color='orange' onClick={() => generateHotPayData(20)} className={"cardpayw"}>
          <Card.Content className='ContentCenter' >
            <span style={{ fontSize: 70, margin: 0, padding: 0 }} className='ContentCenterIcon3'><SiCoffeescript />
            </span>
            <Card.Header>DUŻA KAWA</Card.Header>
            <Card.Meta style={{ fontSize: 12, lineHeight: 1.1,color:"#4B4B4B" }}><Icon name="credit card" /> PŁATNOŚĆ BLIK LUB ONLINE</Card.Meta>
            <Card.Meta style={{ fontSize: 12, lineHeight: 1.1,color:"#4B4B4B" }}><MdDoNotDisturbOff /> BEZ REJESTRACJI</Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <Button basic color='orange' id="buycoffe20click">
              <b>WSPIERAM ZA 20 PLN</b>
            </Button>
            <br/><div style={{fontSize:12,marginTop:5}}>
            Płatność jednorazowa
            </div>
          </Card.Content>
        </Card>
      </Card.Group>

      <Card.Group centered>
        <Card link color='red' onClick={() => generateHotPayData(50)} className={"cardpay"}>
          <Card.Content className='ContentCenter' >
            <span style={{ margin: 0, padding: 0 }} className='ContentCenterIconZestaw'>
              <span style={{ fontSize: 35, margin: 0, padding: 0 }}><SiCoffeescript /></span ><span style={{ fontSize: 55, margin: 0, padding: 0 }}><BiCoffeeTogo /></span>
            </span>
            <Card.Header>ZESTAW</Card.Header>
            <Card.Meta style={{ fontSize: 12, lineHeight: 1.1,color:"#4B4B4B" }}><Icon name="credit card" /> PŁATNOŚĆ BLIK LUB ONLINE</Card.Meta>
            <Card.Meta style={{ fontSize: 12, lineHeight: 1.1,color:"#4B4B4B" }}><MdDoNotDisturbOff /> BEZ REJESTRACJI</Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <Button basic color='red' id="buycoffe50click">
              <b>WSPIERAM ZA 50 PLN</b>
            </Button>
            <br/><div style={{fontSize:12,marginTop:5}}>
            Płatność jednorazowa
            </div>
          </Card.Content>
        </Card>
        <Card link color='orange' onClick={() => generateHotPayData(100)} className={"cardpay"}>
          <Card.Content className='ContentCenter' >
            <span style={{ margin: 0, padding: 0 }} className='ContentCenterIconZestaw2'>
              <span style={{ fontSize: 60, margin: 0, padding: 0 }}><SiBuymeacoffee /></span><span style={{ fontSize: 35, margin: 0, padding: 0 }}><SiCoffeescript /></span ><span style={{ fontSize: 55, margin: 0, padding: 0 }}><BiCoffeeTogo /></span>
            </span>
            <Card.Header>SUPER ZESTAW</Card.Header>
            <Card.Meta style={{ fontSize: 12, lineHeight: 1.1,color:"#4B4B4B" }}><Icon name="credit card" /> PŁATNOŚĆ BLIK LUB ONLINE</Card.Meta>
            <Card.Meta style={{ fontSize: 12, lineHeight: 1.1,color:"#4B4B4B" }}><MdDoNotDisturbOff /> BEZ REJESTRACJI</Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <Button basic color='red' id="buycoffe100click">
              <b>WSPIERAM ZA 100 PLN</b>
            </Button>
            <br/><div style={{fontSize:12,marginTop:5}}>
            Płatność jednorazowa
            </div>
          </Card.Content>
        </Card>
      </Card.Group>
      <br />
      <p>
        Postawienie nam symbolicznej <b>KAWY</b> to jak poklepanie NAS po plecach w stylu: <b><i>dobra robota! Tak trzymać!</i></b><br /> To bardzo NAS motywuje do daleszego działania i rozwijania generatora.<br /> Traktujemy to jako inspirację i potwierdzenie, że nasza praca jest wartościowa.
      </p>
      .:<b>DZIĘKUJEMY ZA WSPARCIE</b>:.
      {form ?
        <form style={{ display: "none" }}
          id="orderHP"
          action="https://platnosc.hotpay.pl/"
          method="post">
          <input required name="SEKRET" value={form.SEKRET} type="hidden" />
          <input required name="HASH" value={form.HASH} type="hidden" />
          <input required name="KWOTA" value={form.KWOTA} type="hidden" />
          <input required name="NAZWA_USLUGI" value={form.NAZWA_USLUGI} type="hidden" />
          <input required name="ADRES_WWW" value={form.ADRES_WWW} type="hidden" />
          <input required name="ID_ZAMOWIENIA" value={form.ID_ZAMOWIENIA} type="hidden" />
          <input name="EMAIL" value={form.EMAIL} type="hidden" />
          <input name="DANE_OSOBOWE" value={form.DANE_OSOBOWE} type="hidden" />
          <button type="submit">Submit</button>
        </form>
        : ""}
    </Container>

  )
}

export default BuyCoffe;